// -----------------------------------------------------------------------------
// AFFILIATE LINK CONFIGURATION
// -----------------------------------------------------------------------------
//
// This file holds the affiliate URLs Sereno uses to earn a small commission
// when a user opens an account at a partner bank/broker via our recommendation.
//
// HOW TO USE:
// 1. Sign up to the affiliate program of each partner (see docs below).
// 2. Once approved, replace the empty string ("") with your tracked URL.
// 3. Save this file. That's it — the app will automatically use the
//    affiliated URL instead of the raw one, and track your commissions.
//
// SIGN-UP LINKS (as of 2026):
// - Boursorama / BoursoBank → sign up on Awin (https://www.awin.com)
//   then search for "Boursorama" or "BoursoBank" in the advertiser directory.
// - Fortuneo → sign up on Awin, search "Fortuneo".
// - Linxea → contact partenariats@linxea.com directly (private program).
// - ING → sign up on Awin, search "ING".
//
// PRIVACY NOTE: Affiliate URLs typically add a `?aff=YOUR_ID` parameter.
// No personal data is shared with the affiliate network — only anonymous clicks.
// -----------------------------------------------------------------------------

export const AFFILIATE_URLS = {
  // French banks & brokers
  boursorama: "", // e.g. "https://track.awin.com/?campaign=boursorama&aff=YOUR_ID"
  boursorama_vie: "", // Assurance-vie Boursorama
  fortuneo: "",
  fortuneo_vie: "",
  linxea: "",
  linxea_avenir_2: "",
  ing: "",

  // Belgian, Swiss, Canadian — to be filled if you expand there
  keytrade: "",
  belfius: "",
  degiro: "",
  swissquote: "",
  wealthsimple: "",
};

/**
 * Returns the affiliated URL if configured, otherwise the raw URL.
 * @param {string} key — a key from AFFILIATE_URLS (e.g. "boursorama")
 * @param {string} fallbackUrl — the direct URL to use if no affiliate URL set
 */
export function affiliateUrl(key, fallbackUrl) {
  const tracked = AFFILIATE_URLS[key];
  if (tracked && tracked.trim()) return tracked;
  // Ensure fallback starts with https://
  if (!fallbackUrl) return null;
  if (fallbackUrl.startsWith("http")) return fallbackUrl;
  return `https://${fallbackUrl}`;
}
